export default __webpack_public_path__ + "static/media/Trace.76297d61.svg";